import { Routes, Route } from "react-router-dom";
import withTenant from './utils/withTenant';
import { useState } from "react";
import { useSelector } from "react-redux";

import NotFound from "./NotFound";
import TokenRedirect from "./pages/TokenRedirect";
import Logout from "./pages/Logout";
import HeaderNavBar from "./components/layout/HeaderNavBar";
import Footer from "./components/layout/Footer";
import MenuSide from "./components/layout/MenuSide";
import DashBoard from "./pages/DashBoard";
import withGuard from "./utils/withGuard";
import { useTenant, useStartup } from "./hooks";
import { MwSpinner } from "./components/ui";
import "./index.css";
import NotificationBar from "./components/layout/NotificationBar";
import Settiings from "./pages/Settiings";
import Products from "./pages/products/Products";
import CreateProduct from "./components/Products/CreateProduct";
import ProductsHome from "./pages/products/ProductsHome";
import Reports from "./pages/Reports";
import OsViewWeights from './components/OsNewWeight/OsViewWeights';
import OsCreateWeight from './components/OsNewWeight/OsCreateWeight';
import OsEditWeight from './components/OsNewWeight/OsEditWeight';
import OsUnitDetails from './components/OsNewWeight/OsUnitDetails';
import OsListRequisition from "./components/OsRequisition/OsListRequisition";
import OsrRequisitionTrans from "./components/OsRequisition/OsrRequisitionTrans";
import OsrRequisitionPull from './components/OsRequisition/OsrRequisitionPull';
import OsrRequisitionPush from './components/OsRequisition/OsrRequisitionPush';
import OsRequisitionViewUpdate from './components/OsRequisition/OsRequisitionViewUpdate';
import HomeWarehouses from "./pages/warehouses/HomeWarehouses";
import StockTakingHome from "./pages/stocktakings/StockTakingHome";
import ShowStockTaking from "./pages/stocktakings/ShowStockTaking";
import RequisitionTable from "./components/OsRequisition/RequisitionTablePage";
import TableStocking from "./pages/stocktakings/TableStocking";
import ReportsHome from "./pages/Reports/ReportsHome";
import Invoice_Requisition from './components/Invoice_Requisition/Invoice_Requisitions';
import OsRequisitionCreatePurchases from "./components/Invoice_Requisition/OsRequisitionCreatePurchases";
import Sales_OsRequisition_Create from "./components/Sales_Invoice_Requisition/Sales_OsRequisition_Create";
import Sales_Invoice_Requisition from "./components/Sales_Invoice_Requisition/Sales_Invoice_Requisitions";
import { AccountSettingsProvider } from "./contexts/AccountSettingsContext";

function App() {
  const [openMenu, setOpenMenu] = useState(false);
  const langState = useSelector((state) => state.lang);
  const {
    tenant,
    tenantUsername,
    loading: loadingTenant,
    companiesList,
    branchesList,
    tenantId,
    companySelected,
    branchSelected,
  } = useTenant();
  const { startup } = useStartup();
  return (
    <AccountSettingsProvider>
      {!loadingTenant && startup ? (
        <div
          dir={langState?.value === "ar" ? "rtl" : "ltr"}
          className="h-screen flex flex-col overflow-hidden"
        >
      <div className="primary-bg-color flex flex-col flex-1 w-full overflow-hidden">
        <NotificationBar />
        <HeaderNavBar
          companySelected={companySelected}
          branchSelected={branchSelected}
          companiesList={companiesList}
          branchesList={branchesList}
          tenantUsername={tenantUsername}
          tenant={tenant}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
        />
        {/* القائمة الجانبية */}
        <MenuSide openMenu={openMenu} setOpenMenu={setOpenMenu} />
        {/* منطقة المحتوى الأبيض */}
        <div
          className={`flex flex-col md:w-[96.5%]  ms-auto  w-[90%] flex-1 p-1 overflow-hidden ${openMenu ? "md:ms-10" : "md:ms-10"
            }`}
        >
          <div
            className="rounded-2xl bg-white border border-white border-[5px] flex-1 overflow-auto"
            style={{
              minHeight:
                "calc(100vh - var(--header-height, 56px) - var(--notification-height, 0px) - var(--footer-height, 28px))",
              maxHeight:
                "calc(100vh - var(--header-height, 56px) - var(--notification-height, 0px) - var(--footer-height, 28px))",
            }}
          >
          <Routes>
  <Route path="/" element={<DashBoard />} />
  <Route path=":tenant/" element={<DashBoard />} />
  <Route path=":tenant/dashboard" element={<DashBoard />} />
  <Route path=":tenant/warehouses" element={<HomeWarehouses/>} />
  <Route path=":tenant/stocktakings" element={<StockTakingHome/>} />
  <Route path=":tenant/stocktakings/show/:id" element={<ShowStockTaking/>} />
  <Route path=":tenant/stocktakings/view-table/:id" element={<TableStocking/>} />
  <Route path=":tenant/token/:token" element={<TokenRedirect />} />
  <Route path=":tenant/logout" element={<Logout />} />
  <Route path=":tenant/settings" element={<Settiings />} />
  <Route  
    path=":tenant/weight/view"  
    element={  
      <OsViewWeights 
      tenantId = {tenantId}

      /> } 
    />
  <Route  
    path=":tenant/weight/create"  
    element={  
      <OsCreateWeight 
      
      /> } 
    />
  <Route  
    path=":tenant/weight/create/:id"  
    element={  
      <OsEditWeight 
      
      /> } 
    />
  <Route  
    path=":tenant/weight/details/:id"  
    element={  
      <OsUnitDetails  
      
      /> } 
    />
  <Route path=":tenant/products-home" element={<ProductsHome/>} />
  <Route path=":tenant/requisition" element={<OsListRequisition/>} />
  <Route path=":tenant/requisitiontrans" element={<OsrRequisitionTrans/>} />
  <Route path=":tenant/requisitionpull" element={<OsrRequisitionPull/>} />
  <Route path=":tenant/requisitionpush" element={<OsrRequisitionPush/>} />
  <Route path=":tenant/requisition-update/:requisitionid" element={<OsRequisitionViewUpdate/>} />
  <Route path=":tenant/requisition-view/:requisitionid" element={<RequisitionTable/>} />
  <Route path=":tenant/products" element={<Products/>} />
  <Route path=":tenant/products/add" element={<CreateProduct/>} />
  <Route path=":tenant/reports" element={<ReportsHome/>} />
  <Route path=":tenant/invoices/create/:id" element={<OsRequisitionCreatePurchases/>} />
  <Route path=":tenant/invoice-requisition" element={<Invoice_Requisition/>} />
  <Route path=":tenant/invoices-requisition/create/:id" element={<Sales_OsRequisition_Create/>} />
  <Route path=":tenant/invoice-sales-requisition" element={<Sales_Invoice_Requisition/>} />
  <Route path="/notfound" element={<NotFound />} />
  <Route path="/*" element={<NotFound />} />
</Routes>
          </div>
        </div>
      </div>

      <footer className="w-full primary-bg-color text-white py-4 text-center">
        <Footer />
      </footer>
    </div>
  ) : (
    <MwSpinner />
  )}
    </AccountSettingsProvider>
  );
}

export default withTenant(withGuard(App));